module.exports = __webpack_public_path__ + "img/seo_gegame_item03.8169ecf.webp";